// ----------------------------------------------------------------------
// <copyright file="Izenda.UserItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var constants = require('logic/data/Izenda.UserAccountConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var action = require('./Izenda.UserItemAction');
  var DeleteIcon = require('share/components/controls/Izenda.DeleteIcon');
  const AuthorizationValidator = require('share/components/hoc/Izenda.AuthorizationValidator'); 
    
  const AuthorizedActiveOrDeactiveUser = AuthorizationValidator()(function ActiveOrDeactiveUser({ active, onClick, userStatus }) {
    const classes = classnames('izenda-UserStatus u_textUnderline', { 'izenda-UserStatus-Deactivate': !active });
    return (
      <a
        className={classes}
        onClick={onClick}>
        {userStatus}
      </a>
    )
  });
      
  var UserItem = action(function (props) {
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var store = props.store;
    var userInfo = props.userInfo;
    var displayName = userInfo.fullName;
    var authorization = props.authorization;
    var classes = classnames('u_paddingAll u_curPointer', 'truncate', { 'u-bgGray': userInfo.selected });
    var userStatus = userInfo.active ? constants.USER_STATE.DEACTIVATE : constants.USER_STATE.ACTIVATE;
    const isIntegrationMode = authorization.isIntegrationMode();
    var onClick = (isIntegrationMode || userInfo.status !== constants.NUMBER_INACTIVE_REASON_STATUS.NO_PASSWORD_SET)
      && !props.readOnly
      && props.onToggleActive;

    return (
      <div className={classes} onClick={props.onSelectUser} >
        <GridLayout>
          <GridLayout.Row className='izenda-RoleItem'>
            <GridLayout.Col cols={7} className="overflow-text">
              <TextHighLight
                highlight={store.model.filterText}
                text={displayName}
                tooltip={displayName}/>
            </GridLayout.Col>

            <GridLayout.Col cols={5} >
              <div className="pull-right" >
                <AuthorizedActiveOrDeactiveUser
                  keys={[permissionKeys.UserSetupActionsEdit]}
                  onClick={onClick}
                  active={userInfo.active}
                  userStatus={userStatus}
                />
                <DeleteIcon
                  keys={[permissionKeys.UserSetupActionsDel]}
                  onClick={props.onDelete}                             
                  disabled={props.readOnly}
                  integrationHidden
                />
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  });

  module.exports = connect()(UserItem);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/MiddlePanel/Izenda.UserItem.jsx